import * as React from 'react';

import { CSSFileViewerArrows, CSSFileViewerArrowsButton, CSSFileViewerStep } from './JRCFileViewer.styles';
import { JRCIcon } from 'components/JRCIcon/JRCIcon';
import { useKeyPress } from 'hooks/UseKeyPress';

const size = 25;

type JRCFileViewerArrowsProps = {
    index: number;
    total: number;
    onRelease: (direction: string) => void;
};

export const JRCFileViewerArrows = ({ index, total, onRelease }: JRCFileViewerArrowsProps) => {
    const arrowLeft = useKeyPress('ArrowLeft', undefined);
    const arrowRight = useKeyPress('ArrowRight', undefined);

    React.useEffect(() => {
        if (!arrowLeft.keyPressed && arrowLeft.keyPressed !== undefined) {
            onRelease('prev');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [arrowLeft.keyPressed]);

    React.useEffect(() => {
        if (!arrowRight.keyPressed && arrowRight.keyPressed !== undefined) {
            onRelease('next');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [arrowRight.keyPressed]);

    return (
        <CSSFileViewerArrows>
            <CSSFileViewerArrowsButton
                onMouseDown={() => arrowLeft.setKeyPressed(true)}
                onMouseUp={() => arrowLeft.setKeyPressed(false)}>
                <div className={arrowLeft.keyPressed ? 'left down' : 'left'}>
                    <JRCIcon name="icon-angle-left" size={size} color="#fff" />
                </div>
            </CSSFileViewerArrowsButton>
            <CSSFileViewerStep>
                {index + 1}/{total}
            </CSSFileViewerStep>
            <CSSFileViewerArrowsButton
                onMouseDown={() => arrowRight.setKeyPressed(true)}
                onMouseUp={() => arrowRight.setKeyPressed(false)}>
                <div className={arrowRight.keyPressed ? 'right down' : 'right'}>
                    <JRCIcon name="icon-angle-right" size={size} color="#fff" />
                </div>
            </CSSFileViewerArrowsButton>
        </CSSFileViewerArrows>
    );
};
